import { Heart } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const SponsorsPage = () => {
  // Partner Principali - Gariglio e Famiglia Rolle
  const mainPartners = [
    {
      name: "Gariglio",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/iu82dbp9_gariglio.png",
    },
    {
      name: "Famiglia Rolle",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/f6xicawu_Famiglia%20Rolle.png",
    },
  ];

  // Altri Partner con logo
  const partners = [
    {
      name: "Martina",
      logo: "https://customer-assets.emergentagent.com/job_fef51c73-3fe9-4a0a-b70a-2a7119fa5032/artifacts/rtowlaxm_martina.jpg",
    },
    {
      name: "Chiusano Immobiliare",
      logo: "https://customer-assets.emergentagent.com/job_fef51c73-3fe9-4a0a-b70a-2a7119fa5032/artifacts/gkwkq72l_chiusano.png",
      darkBg: true,
    },
    {
      name: "Biltek",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/g64i0npx_Biltek.jpeg",
    },
    {
      name: "Blueco",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/0bhuo7zl_Blueco.jpeg",
    },
    {
      name: "Borello Supermercati",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/ys90gy49_Borello.jpeg",
    },
    {
      name: "F.C.E. Soluzione Casa",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/89xelok8_cfe%20soluzione%20casa.jpg",
    },
    {
      name: "CMCI",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/uqpvmlm0_cmci.jpg",
    },
    {
      name: "Conceria Ferrero",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/20qkibj5_Conceria%20Ferrero.jpeg",
    },
    {
      name: "DHD - Directional Horizontal Drilling",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/km7n250l_dhd.png",
    },
    {
      name: "Ekasa Group",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/qlxvp5uz_ekasa.jpeg",
    },
    {
      name: "Esse Service",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/g5sqmic5_esse%20service.jpeg",
    },
    {
      name: "Feel Love",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/yyzp1nzf_feel%20love.png",
      darkBg: true,
    },
    {
      name: "Fideuram",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/tfbzegze_Fideuram.jpeg",
    },
    {
      name: "FJG",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/0dxnmp54_fjg.png",
    },
    {
      name: "Guido Gobino",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/hil5uo2w_guido%20gobino.png",
    },
    {
      name: "King Attitude",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/6xpbgodw_KINGAttitude_Logo-400x250.png",
    },
    {
      name: "La Volpe Osteria Pizzeria",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/ihoqdx5x_la%20volpe.jpeg",
    },
    {
      name: "Officine Maffeis",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/dr7cc9tc_maffeis%20officine.jpg",
    },
    {
      name: "M.C. 2.0 Carrozzeria",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/spiokf9l_mc%20carrozzeria.jpeg",
    },
    {
      name: "Pediatrica",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/62ssefis_pediatrica.png",
    },
    {
      name: "Proxima Servizi Assicurativi",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/recg6txx_proxima.png",
    },
    {
      name: "RBT",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/qgo43dlc_rbt.png",
    },
    {
      name: "Romec",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/axli72qa_Romec.jpeg",
    },
    {
      name: "Tempocasa",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/fai91dxa_tempocasa.png",
    },
    {
      name: "Valmora Acqua Minerale",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/uz3d1djd_valmora.png",
    },
    {
      name: "Valsusa Servizi Ecologici",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/bms7pgkj_Valsusa%20servizi%20ecologici.jpeg",
    },
    {
      name: "Verve Lounge Garden Catering",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/uxcvksoh_verve.jpeg",
    },
    {
      name: "Comune di Volpiano",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/ct72jxje_WhatsApp%20Image%202025-09-30%20at%2020.07.07.jpeg",
    },
    {
      name: "Zamet",
      logo: "https://customer-assets.emergentagent.com/job_volpiano-fc/artifacts/t2c5ovwc_zamet.png",
    },
  ];

  const otherPartners = [
    "Effe e Elle Building",
    "Lorenzo Cucco",
    "A.R.C Simonato",
    "Gica",
    "Beko Technologies",
    "Gualdi",
    "O.G.Impianti di Oddenino",
    "Falegnameria Di Luzio",
    "Dott. De Leo",
    "R5",
    "Consorzio Imprese Torino",
    "G.C.S. srl",
    "Mongardi",
    "Falegnameria Nunziata Antonio",
    "Farmacia Santa Margherita",
    "Mask",
    "S.C. ADF Prod Srl",
    "FBA srl",
    "Panetteria Pasticceria La Colombera",
    "Bianco srl",
    "Veggo Plast",
    "Ci.Ti.Elle",
    "Maglietto",
    "Calderaro",
    "Allumin Ser di Tammarazio Rocco",
    "Ferro",
    "CTL",
    "Movingfluid",
    "Piatino",
    "Vanara",
    "Prunelli Nino",
  ];

  return (
    <div data-testid="sponsors-page">
      <Navbar />

      {/* Hero */}
      <section className="pt-24 lg:pt-32 pb-12 bg-[#0047AB] noise-overlay">
        <div className="max-w-7xl mx-auto px-4 text-center text-white">
          <h1 className="text-4xl lg:text-5xl font-black uppercase mb-4 animate-fade-in-up">
            I Nostri Partner
          </h1>
          <p className="text-blue-200 max-w-xl mx-auto">
            Grazie a tutti coloro che sostengono il G.S.D. Volpiano Pianese
          </p>
        </div>
      </section>

      {/* Main Partners - Gariglio e Famiglia Rolle */}
      <section className="section-padding bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Partner Principali</h2>
            <div className="w-20 h-1 bg-[#0047AB] mx-auto rounded-full"></div>
          </div>

          {/* Main Partners Grid - 2 big cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {mainPartners.map((partner, index) => (
              <div
                key={index}
                className="rounded-2xl p-8 lg:p-12 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center border-2 border-[#0047AB]/10 hover:border-[#0047AB]/30 bg-white"
                data-testid={`main-partner-${index}`}
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-36 lg:max-h-44 w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Other Partners with Logo */}
      <section className="section-padding bg-slate-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Partner</h2>
            <div className="w-20 h-1 bg-[#0047AB] mx-auto rounded-full"></div>
          </div>

          {/* Partners Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-8">
            {partners.map((partner, index) => (
              <div
                key={index}
                className={`rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 flex items-center justify-center border border-slate-100 hover:border-[#0047AB]/20 ${
                  partner.darkBg ? "bg-slate-800" : "bg-white"
                }`}
                data-testid={`partner-${index}`}
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-24 lg:max-h-28 w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Other Partners - Text */}
      <section className="section-padding bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-slate-50 rounded-2xl p-8 lg:p-12 shadow-sm">
            <div className="flex items-center justify-center gap-3 mb-6">
              <Heart className="w-6 h-6 text-red-500" />
              <h2 className="text-xl lg:text-2xl font-bold text-slate-900">
                Si ringrazia anche
              </h2>
              <Heart className="w-6 h-6 text-red-500" />
            </div>
            
            <p className="text-slate-600 text-center leading-relaxed">
              {otherPartners.join(", ")}
            </p>

            <div className="mt-8 pt-6 border-t border-slate-200 text-center">
              <p className="text-sm text-slate-500">
                Il G.S.D. Volpiano Pianese ringrazia tutti i partner per il prezioso supporto
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 bg-[#0047AB]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h3 className="text-xl lg:text-2xl font-bold text-white mb-4">
            Vuoi diventare nostro partner?
          </h3>
          <p className="text-blue-200 mb-6">
            Contattaci per scoprire le opportunità di partnership
          </p>
          <a
            href="/contatti"
            className="inline-block bg-white text-[#0047AB] font-semibold px-8 py-3 rounded-full hover:bg-slate-100 transition-colors"
          >
            Contattaci
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SponsorsPage;
